import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  IconButton,
  Button,
  Tooltip,
} from '@mui/material'
import React from 'react'
import { GroupHeader, GroupItems } from './CreateProcessTemplateDialog'

import DeleteIcon from '@mui/icons-material/Delete'
import { COMPUTED_OPERATION_TYPES, COMPUTED_RESERVED_KEYS } from '../../../utility/constants'
import {
  getItemFromList,
  getKeyOfValue,
  getParamField,
  getPropertyOptions,
  PARAM_TYPES,
  PROPERTIES,
  VALUE_POLARITY,
} from './FieldComputationSetupUI'

const getDestructuredParam = (param, fields, operation, altIndex) => {
  if (param?.startsWith('^^')) {
    let fieldId = param.substring(2, param.indexOf('.'))
    if (param.includes('+') || param.includes('-')) {
      fieldId = param.substring(3, param.indexOf('.'))
    }
    return [COMPUTED_OPERATION_TYPES.MULTIPLY, COMPUTED_OPERATION_TYPES.SUM].includes(operation)
      ? {
          id: new Date().getTime() + altIndex,
          type: 'Field',
          field: getItemFromList(fields, 'id', fieldId),
          polarity: getKeyOfValue(VALUE_POLARITY, param.substring(2, 3)),
          property: param.substring(param.indexOf('.') + 1),
        }
      : {
          id: new Date().getTime() + altIndex,
          type: 'Field',
          field: getItemFromList(fields, 'id', param.substring(2, param.indexOf('.'))),
          polarity: '',
          property: param.substring(param.indexOf('.') + 1),
        }
  } else if (param?.startsWith('**')) {
    return {
      id: new Date().getTime() + altIndex,
      type: 'Keyword',
      field: getKeyOfValue(COMPUTED_RESERVED_KEYS, param.substring(2)),
    }
  } else {
    return {
      id: new Date().getTime() + altIndex,
      type: 'Constant',
      field: param,
    }
  }
}

const AlternateComputationSetupUI = ({
  fields,
  activityTemplateId,
  listData,
  lists,
  altFieldTemplateId,
  setaltFieldTemplateId,
  altComputation,
  setaltComputation,
}) => {
  const addAltParam = (altComputationConfig) => {
    const updated = altComputation.map((compute) => {
      const updatedParams = [...(compute.params || []), '']
      return compute.id === altComputationConfig.id
        ? { ...altComputationConfig, params: updatedParams }
        : compute
    })

    setaltComputation(updated)
  }

  const getSelectedField = (fieldId) => {
    const field = fields?.find((it) => it.id == fieldId)
    if (field) {
      return { value: field, label: field?.field_template_name }
    } else {
      return null
    }
  }

  const matchedField = fields.find((field) => field.id === altFieldTemplateId)
  const listId = matchedField?.list_id

  const relevantListData = listData[`list_data_${listId}`] || []
  const currentActivityFields = fields.filter((it) => it.activity_template_id == activityTemplateId)

  const getAltParamFieldOptions = (operationAlt) => {
    const sourceFields =
      operationAlt === COMPUTED_OPERATION_TYPES.SUM_ACROSS_PROCESS ? fields : currentActivityFields

    return [...sourceFields].sort((a, b) =>
      -(b?.activity_template_name || '').localeCompare(a?.activity_template_name || ''),
    )
  }

  return (
    <div style={{ marginTop: 16 }}>
      {/*Select Alernate Coumputation  field*/}
      <Autocomplete
        sx={{ minWidth: 160 }}
        id="autocomplete-field"
        options={fields.filter((it) => it.data_structure === 'list')}
        groupBy={(option) => option?.activity_template_name}
        size="small"
        getOptionLabel={(item) => item?.field_template_name}
        value={getSelectedField(altFieldTemplateId)?.value || null}
        onChange={(_, v) => {
          setaltFieldTemplateId(v?.id)
        }}
        renderGroup={(alt) => (
          <li key={alt.key}>
            <GroupHeader>{alt.group}</GroupHeader>
            <GroupItems>{alt.children}</GroupItems>
          </li>
        )}
        renderInput={(alt) => (
          <TextField
            {...alt}
            variant="outlined"
            label="Select Alternate Computation Field"
            color="primary"
          />
        )}
      />

      <div
        style={{ padding: '16px', border: '1px solid grey', borderRadius: '8px', marginTop: 16 }}
      >
        {/* Select Alternate Computation field */}
        <div>
          <p>alt:</p>

          {altComputation?.map((altComputationConfig, index) => {
            return (
              <div key={altComputationConfig.id} style={{ marginBottom: '24px' }}>
                <p style={{ margin: 0, minWidth: 20 }}>{index + 1}.</p>

                <Autocomplete
                  style={{ minWidth: '160px', width: '100%' }}
                  id="select-list-id"
                  multiple
                  options={relevantListData.map((it) => ({ value: it, label: it.value }))}
                  size="small"
                  value={
                    altComputationConfig.list_data_ids
                      ?.map((id) => relevantListData.find((item) => item.id === id))
                      ?.filter((item) => item !== undefined)
                      ?.map((item) => ({ value: item, label: item.value })) || []
                  }
                  onChange={(_, value) => {
                    setaltComputation(
                      altComputation.map((it, i) =>
                        i === index ? { ...it, list_data_ids: value.map((v) => v.value.id) } : it
                      )
                    )
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="List Id" color="primary" />
                  )}
                />

                <div style={{ marginTop: '16px' }}>
                  <FormControl
                    variant="outlined"
                    size="small"
                    color="primary"
                    fullWidth
                    key={index}
                    style={{ marginBottom: '16px' }}
                  >
                    <InputLabel id={`select-operation-label-${index}`}>Operation</InputLabel>
                    <Select
                      labelId={`select-operation-label-${index}`}
                      id={`select-operation-${index}`}
                      value={Object.keys(COMPUTED_OPERATION_TYPES).find(
                        (key) =>
                          COMPUTED_OPERATION_TYPES[key] === altComputationConfig.operation_alt
                      )}
                      onChange={(e) => {
                        const selectedOperation = COMPUTED_OPERATION_TYPES[e.target.value]
                        setaltComputation(
                          altComputation.map((it, i) =>
                            i === index ? { ...it, operation_alt: selectedOperation } : it
                          )
                        )
                      }}
                      label="Operation"
                    >
                      {Object.keys(COMPUTED_OPERATION_TYPES).map((key) => (
                        <MenuItem key={key} value={key}>
                          {key}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <p>Alt Params: </p>

                {altComputationConfig.params?.map((compiledParam, paramIndex) => {
                  const paramObj = getDestructuredParam(
                    compiledParam,
                    fields,
                    altComputationConfig.operation_alt,
                    paramIndex
                  )

                  return (
                    <div
                      key={compiledParam.id}
                      style={{
                        display: 'flex',
                        columnGap: 8,
                        marginBottom: 16,
                        alignItems: 'center',
                      }}
                    >
                      <p style={{ margin: 0, minWidth: 20 }}>{paramIndex + 1}.</p>

                      <FormControl
                        variant="outlined"
                        size="small"
                        color="primary"
                        style={{ minWidth: '120px' }}
                      >
                        <InputLabel id="select-option-label">Param Type</InputLabel>
                        <Select
                          style={{ minWidth: 120 }}
                          size="small"
                          color="primary"
                          labelId="select-option-label"
                          id="select-option"
                          value={paramObj.type}
                          onChange={(e) => {
                            setaltComputation(
                              altComputation.map((compute) => {
                                paramObj['type'] = e.target.value
                                const param = getParamField(paramObj, compute.operation_alt)

                                const updatedParams = compute.params.map((_param, ind) => {
                                  return ind === paramIndex ? param : _param
                                })

                                return compute.id === altComputationConfig.id
                                  ? { ...altComputationConfig, params: updatedParams }
                                  : compute
                              })
                            )
                          }}
                          label="Param Type"
                        >
                          {Object.keys(PARAM_TYPES).map((typeKey) => (
                            <MenuItem key={typeKey} value={typeKey}>
                              {typeKey}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {/* Render fields based on the parameter type */}
                      {paramObj.type === 'Field' ? (
                        <Autocomplete
                          sx={{ minWidth: 120 }}
                          id="select-param-field"
                          options={getAltParamFieldOptions(altComputationConfig.operation_alt)}
                          groupBy={(option) => option?.activity_template_name}
                          size="small"
                          getOptionLabel={(item) => item?.field_template_name}
                          value={paramObj.field || null}
                          onChange={(_, v) => {
                            setaltComputation(
                              altComputation.map((compute) => {
                                paramObj['field'] = v
                                const param = getParamField(paramObj, compute.operation_alt)

                                const updatedParams = compute.params.map((_param, ind) => {
                                  return ind === paramIndex ? param : _param
                                })
                                return compute.id === altComputationConfig.id
                                  ? { ...altComputationConfig, params: updatedParams }
                                  : compute
                              })
                            )
                          }}
                          renderGroup={(param) => (
                            <li key={param.key}>
                              <GroupHeader>{param.group}</GroupHeader>
                              <GroupItems>{param.children}</GroupItems>
                            </li>
                          )}
                          renderInput={(altParam) => (
                            <TextField
                              {...altParam}
                              variant="outlined"
                              label="select-param-field"
                              color="primary"
                            />
                          )}
                        />
                      ) : paramObj.type === 'Keyword' ? (
                        <FormControl variant="outlined" size="small" color="primary">
                          <InputLabel id={`select-keyword-label-${paramIndex}`}>Keyword</InputLabel>
                          <Select
                            style={{ minWidth: 160 }}
                            size="small"
                            color="primary"
                            labelId={`select-option-label-${paramIndex}`}
                            id={`select-option-${paramIndex}`}
                            value={paramObj.field}
                            onChange={(e) => {
                              setaltComputation(
                                altComputation.map((compute) => {
                                  paramObj['field'] = e.target.value
                                  const param = getParamField(paramObj, compute.operation_alt)

                                  const updatedParams = compute.params.map((_param, ind) => {
                                    return ind === paramIndex ? param : _param
                                  })
                                  return compute.id === altComputationConfig.id
                                    ? { ...altComputationConfig, params: updatedParams }
                                    : compute
                                })
                              )
                            }}
                            label="Keyword"
                          >
                            {Object.keys(COMPUTED_RESERVED_KEYS).map((it) => (
                              <MenuItem key={it} value={it}>
                                {it}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      ) : (
                        <TextField
                          size="small"
                          value={altComputationConfig.field}
                          label="Static Value"
                          fullWidth
                          onChange={(e) => {
                            setaltComputation(
                              altComputation.map((compute) => {
                                paramObj['field'] = e.target.value
                                const param = getParamField(paramObj, compute.operation_alt)

                                const updatedParams = compute.params.map((_param, ind) => {
                                  return ind === paramIndex ? param : _param
                                })
                                return compute.id === altComputationConfig.id
                                  ? { ...altComputationConfig, params: updatedParams }
                                  : compute
                              })
                            )
                          }}
                        />
                      )}

                      {paramObj.type == 'Field' && paramObj.field && (
                        <FormControl variant="outlined" size="small" color="primary">
                          <InputLabel id="select-option-label">Property</InputLabel>
                          <Select
                            style={{ minWidth: 100 }}
                            size="small"
                            color="primary"
                            labelId="select-option-label"
                            id="select-option"
                            value={paramObj.property}
                            onChange={(e) => {
                              setaltComputation(
                                altComputation.map((compute) => {
                                  paramObj['property'] = e.target.value
                                  const param = getParamField(paramObj, compute.operation_alt)

                                  const updatedParams = compute.params.map((_param, ind) => {
                                    return ind === paramIndex ? param : _param
                                  })
                                  return compute.id === altComputationConfig.id
                                    ? { ...altComputationConfig, params: updatedParams }
                                    : compute
                                })
                              )
                            }}
                            label="Property"
                          >
                            {Object.keys(getPropertyOptions(paramObj.field, lists)).map((it) => {
                              return <MenuItem value={it}>{it}</MenuItem>
                            })}
                          </Select>
                        </FormControl>
                      )}
                      {paramObj.type == 'Field' &&
                        paramObj.field &&
                        (altComputationConfig.operation_alt == COMPUTED_OPERATION_TYPES.SUM ||
                          altComputationConfig.operation_alt ==
                            COMPUTED_OPERATION_TYPES.MULTIPLY) && (
                          <FormControl variant="outlined" size="small" color="primary">
                            <InputLabel id="select-option-label">Polarity</InputLabel>
                            <Select
                              style={{ minWidth: 60 }}
                              size="small"
                              color="primary"
                              labelId="select-option-label"
                              id="select-option"
                              value={paramObj.polarity || '+ve'}
                              onChange={(e) => {
                                setaltComputation(
                                  altComputation.map((compute) => {
                                    paramObj['polarity'] = e.target.value
                                    const param = getParamField(paramObj, compute.operation_alt)

                                    const updatedParams = compute.params.map((_param, ind) => {
                                      return ind === paramIndex ? param : _param
                                    })
                                    return compute.id === altComputationConfig.id
                                      ? { ...altComputationConfig, params: updatedParams }
                                      : compute
                                  })
                                )
                              }}
                              label="Polarity"
                            >
                              {Object.keys(VALUE_POLARITY).map((it) => {
                                return <MenuItem value={it}>{it}</MenuItem>
                              })}
                            </Select>
                          </FormControl>
                        )}
                      {/* Additional fields and buttons for each parameter */}
                      <IconButton
                        key={paramIndex}
                        onClick={() => {
                          setaltComputation(
                            altComputation.map((it, i) => {
                              if (i === index) {
                                return {
                                  ...it,
                                  params: it.params?.filter((p) => p !== compiledParam),
                                }
                              }
                              return it
                            })
                          )
                        }}
                      >
                        <DeleteIcon size="small" />
                      </IconButton>
                    </div>
                  )
                })}

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => addAltParam(altComputationConfig)}
                  >
                    Add Alt Param
                  </Button>
                  <Tooltip title="Delete Alt Computation">
                    <IconButton
                      onClick={() => {
                        setaltComputation(altComputation.filter((_, i) => i !== index))
                      }}
                    >
                      <DeleteIcon size="small" />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default AlternateComputationSetupUI
